// components
import {
  PageSection,
  PageSectionInner,
  PageSectionTitle,
} from '@/components/PageSection';

// styles
import { Story, StoryBlock, Timeline, VideosWrapper } from './Team.styles';
import { VideoFacade } from './VideoFacade';

export function Team({ content }) {
  return (
    <PageSection $off>
      <PageSectionInner>
        <PageSectionTitle>{content.title}</PageSectionTitle>
        <Story>{content.lead}</Story>
        <StoryBlock>
          <h3>{content.story.title}</h3>
          <p>{content.story.paragraph}</p>
        </StoryBlock>
        <Timeline>
          {content.timeline.map((entry) => (
            <li key={`timeline-${entry.year}`}>
              <b>{entry.year}</b>
              <span>{entry.text}</span>
            </li>
          ))}
        </Timeline>
        <VideosWrapper>
          {content.videos.map((video) => (
            <VideoFacade key={video.id} video={video} />
          ))}
        </VideosWrapper>
      </PageSectionInner>
    </PageSection>
  );
}
